import {Button, Col, Popover, Row, Table} from "antd";
import React, {useEffect, useRef, useState} from "react";
import sorters from "../../util/sorters";
import moment from "moment";
import {PREFERRED_DATETIME_FORMAT} from "../../util/time";
import {useDynamicTableHeight} from "../../util/useDynamicTableHeight";
import {getPaginationConfig} from "../../util/showAllPagination";

const RatesTable = ({
                      rates,
                      exports,
                      loading
                    }) => {
  const [exportsMap, setExportsMap] = useState({});
  const tableContainerRef = useRef(null);
  const tableHeight = useDynamicTableHeight(tableContainerRef);

  const columns = [
    {
      title: 'Project Code',
      dataIndex: 'projectCode',
      sorter: (a, b) => sorters.string(a.projectCode, b.projectCode),
      render: i => i ? i : '-'
    }, {
      title: 'Time Contract Terms',
      dataIndex: 'timeContractTerms',
      sorter: (a, b) => sorters.string(a.timeContractTerms, b.timeContractTerms),
      render: i => i ? i : '-'
    }
  ];
  useEffect(() => {
    if (exports !== undefined && exports !== null && exports.length > 0) {
      let map = {};
      exports.forEach(e => {
        map[e.ID] = e;
      });
      setExportsMap(map);
    }
  }, [exports]);

  const rateTable = (rateCodes) => {
    const columns = [
      {
        title: 'Category Code',
        sorter: (a, b) => sorters.string(a.categoryCode, b.categoryCode),
        dataIndex: 'categoryCode'
      },
      {
        title: 'Category Rate',
        sorter: (a, b) => sorters.number(a.contractRate, b.contractRate),
        dataIndex: 'contractRate'
      },
      {
        title: 'Export',
        sorter: (a, b) => sorters.number(a.exportId, b.exportId),
        render: i => i.exportId === 0 ? '-' : exportsMap[i.exportId] ? (
          <Popover
            placement="left"
            overlayStyle={{
              width: "35vw"
            }}
            content={(
              <>
                <Row>
                  <Col span={5}><b>Export ID</b></Col>
                  <Col span={19}>{exportsMap[i.exportId].ID}</Col>
                </Row>
                <Row>
                  <Col span={5}><b>Created By</b></Col>
                  <Col span={19}>{exportsMap[i.exportId].createdByEmail}</Col>
                </Row>
                <Row>
                  <Col span={5}><b>Updated By</b></Col>
                  <Col span={19}>{exportsMap[i.exportId].updatedByEmail}</Col>
                </Row>
              </>
            )}
          >
            <Button>{exportsMap[i.exportId].filename}</Button>
          </Popover>
        ) : '?'
      }, {
        title: 'Status',
        dataIndex: 'status',
        sorter: (a, b) => sorters.string(a.status, b.status)
      }, {
        title: 'Created At',
        dataIndex: 'createdAt',
        sorter: (a, b) => sorters.date(a.CreatedAt, b.CreatedAt),
        width: '225px',
        render: i => i ? moment.utc(i).local().format(PREFERRED_DATETIME_FORMAT) : '-'
      },
    ];


    return (
      <Table
        rowKey="id"
        dataSource={rateCodes}
        columns={columns}
        pagination={false}
      />
    );
  };

  return (
    <>
      <Table
        ref={tableContainerRef}
        rowKey="projectCode"
        dataSource={rates}
        columns={columns}
        expandable={{
          columnTitle: 'View Rate Codes', columnWidth: '150px', expandedRowRender: (r) => {
            return rateTable(r.rateCodes)
          }
        }}
        pagination={getPaginationConfig(rates.length)}
        size="small"
        loading={loading}
        scroll={{y: tableHeight}}
      />
    </>
  );
}

export {RatesTable};